import { useEffect, useState } from "react";
import { ListFieldsType, myTaskContactsListName, myTaskInstructionsFilesLibName, s3cloudUrl, siteUrl, strapiAdminUrl } from "src/api/config";
import { Modal } from "src/components/DialogComponent";
import ImagesList from "src/components/ImagesList";
import HelpIcon from "src/components/ui-icons/menu/HelpIcon";
import { DownloadIcon, FileIcon } from "src/components/ui-icons/upload";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItems } from "src/modules/spItems/actions";
import { selectItems } from "src/modules/spItems/selectors";
import { FileType } from "src/types/main";
import MTHelpPageMobile from "./MTHelpPage.mobile";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { BACKEND_URL } from "../api/api";
import axios from "axios";
import Loading from "src/components/Loading";
import EyeIcon from "src/components/ui-icons/reports/EyeIcon";


export default function MTHelpPage() {
  const dispatch = useAppDispatch();
  const contacts = useAppSelector((state) =>
    selectItems(state, myTaskContactsListName),
  ) as ListFieldsType[typeof myTaskContactsListName][];
  const instructions = useAppSelector((state) => selectItems(state, myTaskInstructionsFilesLibName)) as FileType[];
  const [viewDocMode, setViewDocMode] = useState(false);
  const [imagesDoc, setImagesDoc] = useState<any>([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previeFileId, setPreviewFileId] = useState<any>(null);

  useEffect(() => {
    dispatch(getItems({ listName: myTaskContactsListName }));
    dispatch(getItems({ listName: myTaskInstructionsFilesLibName }));
  }, [dispatch]);

  const downLoadHandle = (e: any, url: string, name: string, idFile: number) => {
    e.preventDefault();
    if (idFile) {
      fetch(`${siteUrlOrSiteApi + encodeURI(url)}`)
        .then((response) => response.blob())
        .then((blob) => {
          const printFile = new File([blob], name, {
            type: blob.type,
            lastModified: moment().unix(),
          });
          console.log("DOWNLOAD_FILE: ", printFile);
          let reader = new FileReader();
          reader.readAsDataURL(printFile);
          reader.onload = function () {
            const src = reader.result;
            const linkDownLoad: HTMLAnchorElement = document.createElement("a");
            linkDownLoad.setAttribute("download", printFile.name);
            // @ts-ignore
            linkDownLoad.setAttribute("href", src);
            linkDownLoad.style.display = "none";
            document.body.appendChild(linkDownLoad);
            linkDownLoad.click();
            document.body.removeChild(linkDownLoad);
          };
        });
    } else {
      const linkDownLoad: HTMLAnchorElement = document.createElement("a");
      linkDownLoad.setAttribute("download", name);
      linkDownLoad.setAttribute("href", url);
      linkDownLoad.style.display = "none";
      document.body.appendChild(linkDownLoad);
      linkDownLoad.click();
      document.body.removeChild(linkDownLoad);
    }
  };

  return <MTHelpPageMobile />;
}
